import { Snackbar, Alert } from '@mui/material';

export default function ToastMessage({
    open,
    message,
    severity = 'info',
    duration = 3000,
    onClose,
}) {
    const handleClose = (_, reason) => {
        if (reason === 'clickaway') return;
        onClose?.();
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                color="primary"
                sx={{ 
                    width: '100%' 
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}